import { render, staticRenderFns } from "./SubmissionShared.vue?vue&type=template&id=7fbfbe7f&scoped=true&"
import script from "./SubmissionShared.vue?vue&type=script&lang=js&"
export * from "./SubmissionShared.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionShared.vue?vue&type=style&index=0&id=7fbfbe7f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbfbe7f",
  null
  
)

export default component.exports